import Vue from 'vue'
import VueRouter from 'vue-router'
import Building from "../pages/Building";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'building',
    component: Building
  },
  {
    path: '/residences',
    name: 'residences',
    component: () => import('../pages/Residences.vue')
  },
  {
    path: '/penthouse',
    name: 'penthouse',
    component: () => import('../pages/Penthouse.vue')
  },
  {
    path: '/neighborhood',
    name: 'neighborhood',
    component: () => import('../pages/Neighborhood.vue')
  },
  {
    path: '/availability',
    name: 'availability',
    component: () => import('../pages/Availability.vue')
  },
  {
    path: '/team',
    name: 'team',
    component: () => import('../pages/Team.vue')
  },
  {
    path: '/press',
    name: 'press',
    component: () => import('../pages/Press.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../pages/Contact.vue')
  }
];

const router = new VueRouter({
  mode: 'history',
  base: '/',
  fallback: true,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
});

export default router
